import React from 'react';
import { connect } from 'react-redux';
import { RecentPoliciesHeader, DisplayRecentPolicies } from '../../components/RecentPolicies';
import { getRecentPoliciesRequest } from '../../components/RecentPolicies/Redux/actions';
import {
  OMM_TABS,
  buildOmmTabParams
} from '../../components/RecentPolicies/Components/RecentPoliciesWrapper';
import SkeletonWrapper from '../NewProductList/components/SkeletonWrapper/SkeletonWrapper';
import { PARTNERS_GUID_ENUM } from '../../routes/PartnersEnum';
import { getPartnerGuid } from '../../lib/access.es6';
import PageNotFound from '../PageNotFound/index.es6';
import Grid from '@material-ui/core/Grid';

// Sales Manager dashboard (OMM only). Lists policies awaiting the FIRST
// maker-checker step ("Sales Approval"). It reuses the New Business data path
// (Un_Confirmed policies over the last 30 days) and filters client-side to the
// first step via DisplayRecentPolicies' makerStage="firstStepOnly". Approval
// itself happens on the policy-processing page reached from "View Policy",
// which already renders the MakerChecks control for the current stage.
class SalesManagerPolicies extends React.Component {
  // The Un Confirmed tab carries the status/date-range params the Sales
  // Manager queue shares (Un_Confirmed, last 30 days, created_at).
  unconfirmedParams() {
    return buildOmmTabParams(OMM_TABS[0]);
  }

  componentWillMount() {
    if (getPartnerGuid() !== PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI) {
      return;
    }

    this.props.dispatch(
      getRecentPoliciesRequest({ page: 1, size: 20, ...this.unconfirmedParams() })
    );
  }

  // Merge pagination calls (which only supply page/size) with the shared
  // status/date-range params so paging stays within the same queue.
  getPolicies = (payload = {}) => {
    this.props.dispatch(
      getRecentPoliciesRequest({ ...this.unconfirmedParams(), ...payload })
    );
  };

  render() {
    if (getPartnerGuid() !== PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI) {
      return <PageNotFound />;
    }

    const { recentPoliciesData } = this.props;
    const {
      policies = [],
      loader = false,
      page = 1,
      size = 20,
      total = 0
    } = recentPoliciesData || {};

    return (
      <>
        <RecentPoliciesHeader title="Sales Manager" />

        {loader ? (
          <SkeletonWrapper loading={loader} />
        ) : (
          <section style={{ padding: '20px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <DisplayRecentPolicies
                  policies={policies}
                  handleNextPage={this.getPolicies}
                  loader={loader}
                  page={page}
                  size={size}
                  total={total}
                  makerStage="firstStepOnly"
                  showStage
                  showBranch
                  emptyMessage="No policies awaiting Sales Approval."
                />
              </Grid>
            </Grid>
          </section>
        )}
      </>
    );
  }
}

export default connect((state) => ({
  recentPoliciesData: state.recentPoliciesData
}))(SalesManagerPolicies);
